import type { SxProps, Theme } from "@mui/material";

/* ── Colour tokens ── */
export const ORANGE = "rgb(224, 120, 40)";
export const ORANGE_DARK = "rgb(201, 98, 26)";
export const ORANGE_GRADIENT = `linear-gradient(135deg, ${ORANGE} 0%, ${ORANGE_DARK} 100%)`;

export const colors = {
  orange: "#F97316",
  orangeLight: "#FDBA74",
  orangeBg: "#FFF7ED",
  orangeText: "#C2410C",
  orangeDeep: "#EA580C",
  orangeDeepText: "#92400E",
  gray50: "#F9FAFB",
  gray100: "#F3F4F6",
  gray200: "#E5E7EB",
  gray300: "#D1D5DB",
  gray400: "#9CA3AF",
  gray500: "#6B7280",
  gray600: "#4B5563",
  gray700: "#374151",
  gray800: "#1F2937",
  white: "#fff",
} as const;

/* ── Reusable sx patterns ── */

export const cardSx: SxProps<Theme> = {
  bgcolor: colors.white,
  borderRadius: "12px",
  border: `1px solid ${colors.gray200}`,
  overflow: "hidden",
  flexShrink: 0,
};

export const sectionHeaderSx = (active: boolean): SxProps<Theme> => ({
  display: "flex",
  alignItems: "center",
  gap: 1.5,
  px: 2,
  py: 1.5,
  cursor: "pointer",
  userSelect: "none",
  bgcolor: active ? colors.orangeBg : colors.gray50,
  transition: "background 150ms",
});

export const sectionLabelSx = (active: boolean): SxProps<Theme> => ({
  display: "flex",
  alignItems: "center",
  gap: 1,
  color: active ? colors.orangeText : colors.gray700,
});

export const formatBtnSx = (active: boolean): SxProps<Theme> => ({
  px: 1.5,
  py: 0.75,
  borderRadius: "8px",
  fontSize: "0.75rem",
  fontWeight: 500,
  border: "1px solid",
  cursor: "pointer",
  transition: "all 150ms",
  ...(active
    ? { bgcolor: colors.orange, borderColor: colors.orange, color: colors.white, boxShadow: "0 1px 2px rgba(0,0,0,0.05)" }
    : { bgcolor: colors.white, borderColor: colors.gray200, color: colors.gray600, "&:hover": { borderColor: colors.orangeLight, color: colors.orangeDeep } }),
});

export const textSm: SxProps<Theme> = { fontSize: "0.875rem", fontWeight: 600 };
export const textXs: SxProps<Theme> = { fontSize: "0.75rem" };
